const useLanding = () => ({});

export default useLanding;
